export const seoConfig = {
  "/": {
    title: "Sicunet - Advanced Access Control & Video Surveillance Solutions",
    description:
      "Sicunet provides top-tier access control solutions, including cloud, on-premise, and hybrid systems, along with video surveillance and advanced features like Mifare EV2 credentials and mobile access.",
    keywords:
      "cloud access control, on-premise access control, hybrid access control, video surveillance, Mifare EV2 credentials, mobile access control, Neptune 2.0, Linear Emerge",
    type: "website",
  },
  "/login": {
    title: "Login - Access Your Sicunet Account",
    description:
      "Login to your Sicunet account to access documentation, tutorials, and manage your access control systems.",
    keywords: "Login, User Login, Account Access, Sicunet Login, Secure Login",
    type: "website",
  },
  "/product": {
    title:
      "Access Control Products - Cloud, On-Premise & Hybrid Solutions | Sicunet",
    description:
      "Explore Sicunet's comprehensive range of access control products including Linear Emerge, Neptune 2.0, Mifare EV2 readers, mobile credentials, and integrated video surveillance systems.",
    keywords:
      "Linear Emerge 50, Linear Emerge 5000, Neptune 2.0, Mifare EV2 Reader, Mifare EV2 Credential, Mobile Credentials, access control products, cloud access control systems",
    type: "product",
  },
  "/company": {
    title:
      "About Sicunet - Leading Access Control & Security Solutions Provider",
    description:
      "Learn about Sicunet's mission to provide cutting-edge access control and video surveillance solutions. Discover our expertise in cloud, on-premise, and hybrid security systems.",
    keywords:
      "Sicunet, Access Control Company, Security Solutions Provider, Video Surveillance, Access Control Expert, Security System Integration",
    type: "website",
  },
  "/user-interface": {
    title: "User Interface - Intuitive Access Control Management | Sicunet",
    description:
      "Experience Sicunet's intuitive user interface for seamless access control management. Easy-to-use dashboard for monitoring and controlling your security systems.",
    keywords:
      "User Interface, Access Control UI, Security Dashboard, System Management, Control Panel, Easy Access Control",
    type: "website",
  },
  "/cloud": {
    title: "RMC - Remote Management Cloud | Cloud Access Control | Sicunet",
    description:
      "Manage your access control systems from anywhere with Sicunet's RMC (Remote Management Cloud). Powerful cloud-based access control solution with real-time monitoring.",
    keywords:
      "RMC, Remote Management Cloud, Cloud Access Control, Remote Monitoring, Cloud-Based Security, Real-Time Access Control",
    type: "product",
  },
  "/cloud-plus": {
    title: "RMC Plus - Enhanced Cloud Management Features | Sicunet",
    description:
      "Advanced cloud access control with RMC Plus. Enhanced features, improved performance, and superior remote management capabilities for enterprise security.",
    keywords:
      "RMC Plus, Cloud Plus, Enhanced Access Control, Enterprise Security, Advanced Cloud Features, Premium Access Control",
    type: "product",
  },
  "/true-cloud": {
    title: "True Cloud - Pure Cloud Access Control Solution | Sicunet",
    description:
      "Experience true cloud access control with Sicunet's 100% cloud-based solution. No on-premise servers required, complete scalability and flexibility.",
    keywords:
      "True Cloud, Pure Cloud, Cloud-Only Access Control, Scalable Security, Cloud-Based System, No Server Access Control",
    type: "product",
  },
  "/e3-takeover": {
    title: "E3 Take Over & Retrofit Products - Legacy System Upgrade | Sicunet",
    description:
      "Upgrade your legacy Linear E3, Nice E3, or Nortek E3 access control systems with Sicunet's takeover and retrofit solutions. Seamless migration to modern cloud-based systems.",
    keywords:
      "E3 Takeover, Linear E3 Conversion, Nice E3 Upgrade, Nortek E3 Retrofit, Legacy System Upgrade, E3 Migration, E3 Firmware Upgrade",
    type: "product",
  },
  "/mobile-credential": {
    title: "Mobile Credentials - Smartphone Access Control | Sicunet",
    description:
      "Transform your smartphone into an access credential with Sicunet's mobile credential solution. Secure, convenient, and contactless access using Mifare EV2 technology.",
    keywords:
      "Mobile Credentials, Smartphone Access, Mobile Access Control, Digital Credentials, Contactless Access, Mifare EV2 Mobile, Wallet Credential",
    type: "product",
  },
  "/mobile-link": {
    title: "Mobile Management - Remote Access Control App | Sicunet",
    description:
      "Manage your access control systems on-the-go with Sicunet's mobile management application. Monitor, control, and respond to security events from your smartphone.",
    keywords:
      "Mobile Management, Mobile App, Remote Management, Mobile Access, Smartphone Control, Mobile Security App",
    type: "product",
  },
  "/video-integration": {
    title: "Video Integration - NVR & Camera Integration | Sicunet",
    description:
      "Integrate video surveillance with access control systems. Sicunet supports major NVR brands and IP cameras for comprehensive security monitoring.",
    keywords:
      "Video Integration, NVR Integration, IP Camera, Video Surveillance, CCTV Integration, Security Cameras, Video Management",
    type: "product",
  },
  "/schlage-lockset": {
    title: "Wireless Locksets - Smart Lock Integration | Sicunet",
    description:
      "Integrate wireless locksets with your access control system. Support for Schlage and other leading smart lock manufacturers for complete building security.",
    keywords:
      "Wireless Lockset, Smart Locks, Schlage Integration, Electronic Locks, Door Lock Control, Keyless Entry",
    type: "product",
  },
  "/smart-report": {
    title: "Smart Reports - Advanced Analytics & Reporting | Sicunet",
    description:
      "Generate comprehensive reports and analytics for your access control system. Track usage patterns, security events, and system performance with smart reporting tools.",
    keywords:
      "Smart Reports, Access Control Analytics, Security Reports, Usage Analytics, System Reports, Data Analytics",
    type: "product",
  },
  "/video-recording": {
    title: "Video Recording - Integrated Recording Solutions | Sicunet",
    description:
      "Professional video recording integrated with access control events. Automatic video capture triggered by door access, alarms, and security events.",
    keywords:
      "Video Recording, Event Recording, Access Control Video, Security Recording, Automated Recording, Event-Based Video",
    type: "product",
  },
  "/mobile-applications": {
    title: "Mobile Applications - iOS & Android Apps | Sicunet",
    description:
      "Download Sicunet's mobile applications for iOS and Android. Full-featured mobile access to your security systems with push notifications and real-time monitoring.",
    keywords:
      "Mobile Applications, iOS App, Android App, Mobile Security, Security Apps, Access Control Mobile",
    type: "product",
  },
  "/badging": {
    title: "Badging System - ID Card & Credential Management | Sicunet",
    description:
      "Comprehensive badging and credential management system. Design, print, and manage access cards, employee badges, and visitor credentials.",
    keywords:
      "Badging System, ID Card, Access Cards, Credential Management, Badge Printing, Employee Badges, Visitor Management",
    type: "product",
  },
  "/video-recording-tagging": {
    title: "Video Recording & Tagging - Event-Based Video Management | Sicunet",
    description:
      "Advanced video recording with intelligent tagging. Automatically tag and categorize video footage based on access control events for easy search and retrieval.",
    keywords:
      "Video Tagging, Video Recording, Event Tagging, Video Management, Smart Video, Video Search, Access Control Video",
    type: "product",
  },
  "/tenant-video": {
    title: "Tenant Video Directory Intercom - Building Communication | Sicunet",
    description:
      "Video directory intercom system for multi-tenant buildings. Secure visitor management with video calling, remote door release, and tenant directory.",
    keywords:
      "Video Intercom, Directory Intercom, Tenant Directory, Video Calling, Visitor Management, Building Intercom, Remote Access",
    type: "product",
  },
  "/directory": {
    title:
      " Directory Door Controller Intercom - Secure Visitor Access | Sicunet",
    description:
      "Sicunet's  video directory intercom for multi-tenant buildings offers video calling with two-way audio, remote unlock, self-view preview, searchable tenant directory, PIN entry keypad, email enrollment, mobile credential issuance, DSP noise cancellation, AES-256 encryption, Mifare/QR code readers, IP66-rated indoor/outdoor design, and full integration with Sicunet cloud or on-premise systems.",
    keywords:
      " Directory Door Controller, Video Intercom, Tenant Directory Intercom, Video Calling Intercom, Remote Unlock, Visitor Management, Multi-Tenant Intercom, QR Code Reader, Mifare Reader, Building Intercom System, Video Directory, Access Control Intercom",
    type: "product",
  },
  "/warrantypolicy": {
    title: "Warranty Policy - Sicunet Product Warranty Information",
    description:
      "Learn about Sicunet's warranty policy for access control products and video surveillance systems. Understand coverage, terms, and support services.",
    keywords:
      "Warranty Policy, Product Warranty, Access Control Warranty, Support Services, Product Guarantee, Warranty Coverage",
    type: "website",
  },
  "/documentation-library": {
    title: "Documentation Library - Access Control Guides & Manuals | Sicunet",
    description:
      "Access comprehensive documentation, installation guides, user manuals, and technical resources for Sicunet's access control and video surveillance products.",
    keywords:
      "Documentation, User Manuals, Installation Guides, Technical Documentation, Product Guides, Setup Instructions, Access Control Manuals",
    type: "website",
  },
  "/tuitorial-library": {
    title: "Tutorial Library - Video Guides & How-To Resources | Sicunet",
    description:
      "Browse Sicunet's tutorial library featuring video guides, step-by-step instructions, and training materials for access control systems.",
    keywords:
      "Video Tutorials, How-To Guides, Training Videos, Setup Tutorials, Product Training, Installation Videos, Tutorial Library",
    type: "website",
  },
  "/privacypolicy": {
    title: "Privacy Policy - Sicunet Data Protection & Security",
    description:
      "Read Sicunet's privacy policy to understand how we collect, use, and protect your personal information and data security practices.",
    keywords:
      "Privacy Policy, Data Protection, Security Privacy, Information Security, GDPR Compliance, Data Privacy",
    type: "website",
  },
  "/releasenote": {
    title: "Release Notes - Latest Updates & Features | Sicunet",
    description:
      "Stay updated with the latest release notes, software updates, new features, and improvements for Sicunet's access control products.",
    keywords:
      "Release Notes, Software Updates, New Features, Product Updates, Version History, Changelog, System Updates",
    type: "website",
  },
  "/contact-us": {
    title: "Contact Sicunet - Get Expert Access Control Support",
    description:
      "Contact Sicunet for expert consultation on access control systems, video surveillance, and security solutions. Reach our team for product inquiries, technical support, and demos.",
    keywords:
      "Contact Sicunet, Access Control Support, Security System Consultation, Product Demo, Technical Support, Security Solutions Inquiry",
    type: "website",
  },
  "/feedback": {
    title: "Feedback - Share Your Experience with Sicunet",
    description:
      "Share your feedback and experience with Sicunet's products and services. Help us improve our access control and security solutions.",
    keywords:
      "Customer Feedback, Product Reviews, User Experience, Service Feedback, Customer Satisfaction, Product Feedback",
    type: "website",
  },
  "/request-demo": {
    title: "Request a Demo - Experience Sicunet Access Control Solutions",
    description:
      "Request a personalized demo of Sicunet's access control and video surveillance solutions. See how our cloud, on-premise, and hybrid systems can enhance your security.",
    keywords:
      "Request Demo, Access Control Demo, Product Demonstration, Security System Trial, Live Demo, Product Showcase",
    type: "website",
  },
};

export const getSEOData = (path) => {
  // Handle dynamic product routes
  if (path.startsWith("/product/")) {
    return {
      title: "Product Details - Access Control Solutions | Sicunet",
      description:
        "Detailed information about Sicunet's access control products. Specifications, features, and pricing for our comprehensive security solutions.",
      keywords:
        "Product Details, Access Control Product, Security Product, Product Specifications, Product Features",
      type: "product",
    };
  }

  return seoConfig[path] || seoConfig["/"];
};
